// src/components/BuyMeACoffee.js
import React from 'react';

// Your Buy Me a Coffee page: https://buymeacoffee.com/wsxcoding
export const BUY_ME_A_COFFEE_USERNAME = 'wsxcoding';
export const BUY_ME_A_COFFEE_URL = `https://www.buymeacoffee.com/${BUY_ME_A_COFFEE_USERNAME}`;

// Inline coffee cup icon (no extra dependency)
const CoffeeIcon = ({ className = 'w-5 h-5' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M18 8h1a4 4 0 0 1 0 8h-1" />
    <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z" />
    <line x1="6" y1="1" x2="6" y2="4" />
    <line x1="10" y1="1" x2="10" y2="4" />
    <line x1="14" y1="1" x2="14" y2="4" />
  </svg>
);

/**
 * Inline button — drop into a footer, a result card, etc.
 */
export const BuyMeACoffeeButton = ({ className = '' }) => (
  <a
    href={BUY_ME_A_COFFEE_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Cumpără-mi o cafea pe Buy Me a Coffee"
    className={`group inline-flex items-center justify-center space-x-2 px-5 py-3 rounded-2xl font-bold text-[#0d0c22] bg-gradient-to-r from-[#FFDD00] to-[#FBB034] hover:from-[#ffe533] hover:to-[#ffc04d] transition-all duration-200 active:scale-[0.98] shadow-lg shadow-amber-500/25 ${className}`}
  >
    <CoffeeIcon className="w-5 h-5 transition-transform duration-300 group-hover:-rotate-12" />
    <span>Cumpără-mi o cafea</span>
  </a>
);

/**
 * Floating button — render once at the app root so it shows on every page.
 * Positioned bottom-right, lifted on mobile so it never overlaps the
 * calculator's sticky action bar.
 */
export const FloatingCoffeeButton = () => (
  <a
    href={BUY_ME_A_COFFEE_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Cumpără-mi o cafea pe Buy Me a Coffee"
    className="fixed z-40 right-4 bottom-24 md:right-6 md:bottom-6 group inline-flex items-center justify-center bg-gradient-to-r from-[#FFDD00] to-[#FBB034] text-[#0d0c22] font-bold rounded-full shadow-xl shadow-amber-500/40 ring-1 ring-black/5 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-amber-500/50 active:scale-95 h-14 w-14 sm:w-auto sm:h-auto sm:px-5 sm:py-3.5 sm:space-x-2"
  >
    {/* Attention pulse ring (behind the button) */}
    <span className="pointer-events-none absolute inset-0 rounded-full bg-amber-400/60 animate-ping opacity-40 -z-10" aria-hidden="true" />
    <CoffeeIcon className="w-6 h-6 sm:w-5 sm:h-5 transition-transform duration-300 group-hover:-rotate-12" />
    <span className="hidden sm:inline whitespace-nowrap">Cumpără-mi o cafea</span>
  </a>
);

export default BuyMeACoffeeButton;
